<template>
    <div class="app-page">
        <Header ref="header" helpURL="studio/datasets/">
        <template #page-slot>            
            Apps
        </template>
        </Header>
            <div class="main-page-div">
            <main id="drop-area" class="main-display-area" >
                <router-view />
 
                <div class="div-buttons">
                    <button @click="tab=''" :class="['tab-button', { active: tab === '' }]" >Available Apps</button>
                    <button @click="tab='running'" :class="['tab-button', { active: tab === 'running' }]">Running Apps</button>
                </div>

                <div v-if="tab==''" class="scroll">
                    <Apps 
                        @job_started="tab='running'"
                    />
                </div>
                <div v-else class="scroll">
                     <AppsRunning />
                </div>

        </main>
    </div>
    </div>
</template>

<script setup>

import {ref} from 'vue'
import Header from '@/components/Header.vue';
import Apps from '@/components/Apps/AppsList.vue';
import AppsRunning from '@/components/Apps/AppsListRunning.vue';

const tab = ref('');


</script>

<style lang="scss" scoped>

a {
  text-decoration: none;
    color:#dfe0e0;
}

.scroll {
    overflow: auto;
    width: 100%;
}

.tab-button {
  width: 220px;
  padding: 3px;
  text-align: center;
  font-size: 1.2rem;
  font-weight: 500;
  cursor: pointer;
  color: #838383;
 
}
.tab-button.active {
  border-bottom:4px solid rgb(6, 54, 85);
  color: #000000;
}

.tab-button:hover {
  color: #000000;

}
.div-buttons {
    width: 100%;
    border-bottom:1px solid rgb(211, 212, 213)
}

</style>
